import React from 'react';

import { useContactsSelector } from '@components/ContactsSelector/Common/ContactsSelectorContext';
import ModelsTableAccounting from '@components/ContactsSelector/ModelsSelector/ModelsWall/ModelsTableAccounting/ModelsTableAccounting';
import CenteredBlock from '@components/Gui/CenteredBlock';
import EmptyState from '@components/Gui/EmptyState';
import { Loading } from '@components/Gui/Loading';
import { NwCard } from '@components/Gui/NwCard/NwCard';

import { WallContainer } from '../ModelsTable/ModelsTableUI';

const ModelsTableAccountingWrapper = ({ footer, isLoading, models }) => {
    const { layout } = useContactsSelector();

    return (
        <>
            <WallContainer>
                {isLoading ? (
                    <Loading loadingType="centered" />
                ) : models.length ? (
                    <NwCard className="modeltable-card-wrapper" padding={layout.drawer ? 'no' : ''}>
                        <ModelsTableAccounting list={models} />
                    </NwCard>
                ) : (
                    <CenteredBlock>
                        <EmptyState message="no models fitting your search" />
                    </CenteredBlock>
                )}
            </WallContainer>
            {footer}
        </>
    );
};

export default ModelsTableAccountingWrapper;
